import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  GetAllUsers,
  GetSearchData,
} from '../../../redux/admin/customer/customer_services_sync';
import { Skeleton } from '@mui/material';
import { TableLoader } from '../../../component/loader/Table_Loader';
import EmptyComponent from '../../../component/EmptyComponent';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import {
  updateCurrentRoom,
  updateSelectedRoom,
} from '../../../redux/admin/admin_room/roomSlice';
import { AppContext } from '../../../context/context';
import { useDebouncedCallback } from 'use-debounce';

const Customers_List = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.profile);

  const { current_room } = useSelector((state) => state.admin_room);

  const [searchCustomer, setSearchCustomer] = useState('');

  const {
    customersSearchdata,
    customers,
    customer_loader,
    customerCount,
    customerLimit,
    customerSkip,
  } = useSelector((state) => state.customers);

  useEffect(() => {
    dispatch(GetAllUsers({ page: customerSkip, limit: customerLimit }));
  }, []);

  const handlePageChange = (page) => {
    dispatch(
      GetAllUsers({
        page: page,
        limit: customerLimit,
      })
    );
  };

  const JoinRoom = async (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    await navigate('/admin_dashboard/support_chat');

    socket.emit('customer-admin-join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          GetSearchData({
            name: value,
            page: 0,
            limit: customerLimit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchCustomer(value);

    if (value) {
      debounced(value);
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 col-xl-3">
          {customer_loader ? (
            <Skeleton height={230} width={'100%'} style={{ margin: 0 }} />
          ) : (
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center gap-2 mb-3">
                  <div class="avatar-md bg-primary bg-opacity-10 rounded">
                    <iconify-icon
                      icon="solar:users-group-two-rounded-bold-duotone"
                      class="fs-32 text-primary avatar-title"
                    ></iconify-icon>
                  </div>
                  <div>
                    <h4 class="mb-0">All Customers</h4>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="text-muted fw-medium fs-22 mb-0">{customerCount}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchCustomer || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="d-flex card-header justify-content-between align-items-center">
              <div>
                <h4 class="card-title">All Customers List</h4>
              </div>
            </div>
            <div>
              {customer_loader ? (
                <TableLoader
                  headerArray={[
                    'Customer Name',
                    'Customer email',
                    'Customer Number',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th>Customer Name</th>
                        <th>Customer email</th>
                        <th>Customer Number</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchCustomer ? (
                        customersSearchdata?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          customersSearchdata?.docs?.map((item, key) => (
                            <tr key={key}>
                              <td
                                onClick={() => {
                                  const payload = {
                                    ...item,
                                    room: `user-${item?._id}-admin`,
                                  };

                                  JoinRoom(payload, current_room);
                                }}
                              >
                                <img
                                  src="/assets/img/avatar-profile-photo.png"
                                  class="avatar-sm rounded-circle me-2"
                                  alt="..."
                                />
                                {item?.name}
                              </td>
                              <td>
                                <a
                                  href="javascript: void(0);"
                                  class="text-body"
                                >
                                  {item?.email}
                                </a>
                              </td>

                              <td>{item?.phone_number}</td>

                              <td>
                                <div class="d-flex gap-2">
                                  <NavLink
                                    to={`/admin_dashboard/view_customer/${item?._id}`}
                                  >
                                    <a class="btn btn-light btn-sm">
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </NavLink>
                                </div>
                              </td>
                            </tr>
                          ))
                        )
                      ) : customers?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        customers?.docs?.map((item, key) => (
                          <tr key={key}>
                            <td
                              onClick={() => {
                                const payload = {
                                  ...item,
                                  room: `user-${item?._id}-admin`,
                                };

                                JoinRoom(payload, current_room);
                              }}
                            >
                              <img
                                src="/assets/img/avatar-profile-photo.png"
                                class="avatar-sm rounded-circle me-2"
                                alt="..."
                              />
                              {item?.name}
                            </td>
                            <td>
                              <a href="javascript: void(0);" class="text-body">
                                {item?.email}
                              </a>
                            </td>

                            <td>{item?.phone_number}</td>

                            <td>
                              <div class="d-flex gap-2">
                                <NavLink
                                  to={`/admin_dashboard/view_customer/${item?._id}`}
                                >
                                  <a class="btn btn-light btn-sm">
                                    <iconify-icon
                                      icon="solar:eye-broken"
                                      class="align-middle fs-18"
                                    ></iconify-icon>
                                  </a>
                                </NavLink>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={customers?.page}
                  totalItems={customers?.totalDocs}
                  pageSize={customerLimit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers_List;
